var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Item } from 'aigens-ng-core';
import { Injector, OnDestroy, OnInit } from '@angular/core';
import { VariationDialog } from '../../dialogs/variation/variation';
import { getSetLayout } from '../../shared/utilities/layout-helper';
import { BaseCategoryListPage } from '../../core/base/base-category-list-page';
var CategoryGroupListPage = /** @class */ (function (_super) {
    __extends(CategoryGroupListPage, _super);
    function CategoryGroupListPage(injector) {
        var _this = _super.call(this, injector) || this;
        _this.listMode = false;
        _this.mode = 'grid';
        _this.imgs = [];
        _this.isTreats = false;
        _this.currentCategoryIndex = 0;
        _this.isVariationOpened = false;
        _this.preOrder = false;
        _this.temp = false;
        _this.showTransitAni = false;
        _this.modifiableMap = {};
        _this.requiredModifierMap = {};
        _this.categoryGroupMap = {};
        _this.categoryWithoutGroupMap = {};
        _this.keyMapArray = [];
        _this.currentCategories = [];
        _this.hasRecommendation = false;
        _this.recommendationGroups = [];
        _this.sortBy = 'full';
        console.log('cat list construction');
        _this.preOrder = _this.orderService.preOrder;
        _this.isTreats = _this.getNavParams('isTreats');
        var store = _this.getNavParams('store');
        var storeId = _this.getNavParams('storeId');
        if (store) {
            _this.store = store;
            _this.storeId = store.id;
            if (_this.multOrderManager.enableMutlOrder) {
                _this.settingMultiOrderManager();
            }
            else if (_this.orderManager.isEmpty()) {
                _this.orderManager.createOrder(_this.storeId, null, null, null, _this.store);
            }
            _this.orderManager.settingOrderType(_this.orderManager.mode);
            _this.showStore(store);
        }
        else if (storeId) {
            _this.storeId = storeId;
            if (_this.multOrderManager.enableMutlOrder) {
                _this.settingMultiOrderManager();
            }
            else if (_this.orderManager.isEmpty()) {
                _this.orderManager.createOrder(_this.storeId, null, null, null, _this.store);
            }
            _this.orderManager.settingOrderType(_this.orderManager.mode);
        }
        var now = _this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        var cats = _this.menuManager.getAvailableCategories(store, now, _this.orderManager.mode === 'takeaway');
        console.log('category group page -- cats', cats);
        if (!cats) {
            return _this;
        }
        if (cats) {
            for (var _i = 0, cats_1 = cats; _i < cats_1.length; _i++) {
                var cat = cats_1[_i];
                var applied = false;
                for (var _a = 0, _b = _this.store.menu.cgroups; _a < _b.length; _a++) {
                    var cgroup = _b[_a];
                    if (cgroup.categoryIds && cgroup.categoryIds.indexOf(cat.id) >= 0) {
                        applied = true;
                        if (!_this.categoryGroupMap[cgroup.name]) {
                            _this.categoryGroupMap[cgroup.name] = [];
                            _this.categoryGroupMap[cgroup.name].push(cat);
                        }
                        else {
                            _this.categoryGroupMap[cgroup.name].push(cat);
                        }
                        break;
                    }
                }
                // !applied
                if (!applied) {
                    if (!_this.categoryWithoutGroupMap['Category']) {
                        _this.categoryWithoutGroupMap['Category'] = [];
                        _this.categoryWithoutGroupMap['Category'].push(cat);
                    }
                    else {
                        _this.categoryWithoutGroupMap['Category'].push(cat);
                    }
                }
            }
        }
        console.log('this.categoryGroupMap', _this.categoryGroupMap);
        var keys = Object.keys(_this.categoryGroupMap);
        for (var _c = 0, _d = _this.store.menu.cgroups; _c < _d.length; _c++) {
            var cgroup = _d[_c];
            if (keys.indexOf(cgroup.name) >= 0)
                _this.keyMapArray.push(cgroup.name);
        }
        _this.currentCategories = _this.categoryGroupMap[_this.keyMapArray[0]];
        return _this;
    }
    CategoryGroupListPage.prototype.settingAiRecommendation = function () {
        var member = this.memberService.getMember();
        if (!member) {
            this.getRecommendation({});
        }
        else {
            this.getRecommendation(member);
        }
    };
    CategoryGroupListPage.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (!this.store && this.storeId) {
            this.getStore();
        }
        if (this.settings.aiRecommendCount && this.settings.aiRecommendCount > 0) {
            this.settingAiRecommendation();
        }
        else {
            this.allowToView = true;
        }
    };
    CategoryGroupListPage.prototype.getRecommendation = function (mem) {
        var _this = this;
        this.loading(true);
        this.aiService.getRecommend(mem).subscribe(function (behavior) {
            _this.allowToView = true;
            _this.loading(false);
            console.log('behavior', behavior);
            _this.behavior = behavior.food;
            var recoms;
            var member = _this.memberService.getMember();
            if (!member) {
                recoms = _this.recommendationManager.makeRecommendations(_this.store.menu, null, behavior.food, 'single', 200);
            }
            else {
                recoms = _this.recommendationManager.makeRecommendations(_this.store.menu, member, behavior.food, 'single', 200);
            }
            // this.recommendations = this.menuManager.getAvailableRecommendation
            _this.recommendations = _this.menuManager.getAvailableRecommendations(_this.store, recoms);
            _this.hasRecommendation = _this.recommendations && _this.recommendations.length > 0;
            console.log('ai recommendation', _this.recommendations);
            _this.recommendationGroups = _this.recommendationManager.groupRecommendations(_this.recommendations, _this.sortBy);
            // filtering
            _this.recommendationGroups = _this.recommendationGroups.filter(function (recomG) {
                var order = _this.orderManager.getOrder();
                for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
                    var oi = _a[_i];
                    // only check for a le carte item
                    if (oi.items && oi.items.length === 1) {
                        // if (oi.items[0].id === recom.item.id) {
                        //     console.log("same item now remove", recom.item.name);
                        //     return false;
                        // }
                        for (var _b = 0, _c = recomG.recommendations; _b < _c.length; _b++) {
                            var recom = _c[_b];
                            if (oi.items[0].id === recom.item.id) {
                                console.log('same item now remove', recom.item.name);
                                return false;
                            }
                        }
                    }
                }
                return true;
            });
            _this.recommendationGroups = _this.recommendationGroups.slice(0, _this.settings.aiRecommendCount);
            console.log('recommendationGroups', _this.recommendationGroups);
            // if(this.memberService.getMember())
            // {
            //     this.recommendations.sort((a,b) => (a["reasons"][0]["score"] < b["reasons"][0]["score"]) ? 1 : ((b["reasons"][0]["score"] < a["reasons"][0]["score"]) ? -1 : 0));
            //     //this.recommendations.sort((a,b) => (a["reasons"][2]["value"] < b["reasons"][2]["value"]) ? 1 : ((b["reasons"][2]["value"] < a["reasons"][2]["value"]) ? -1 : 0));
            //     //this.recommendations.reverse();
            // }else
            // {
            //     this.recommendations.sort((a,b) => (a["reasons"][2]["value"] < b["reasons"][2]["value"]) ? 1 : ((b["reasons"][2]["value"] < a["reasons"][2]["value"]) ? -1 : 0));
            // }
        }, function (err) {
            _this.allowToView = true;
            _this.loading(false);
            _this.showError(err);
        });
    };
    CategoryGroupListPage.prototype.getStore = function () {
        var _this = this;
        this.loading(true);
        this.menuService.getStore(this.storeId).subscribe(function (store) {
            _this.store = store;
            _this.setTheme(store.brand, store);
            _this.defaultImage = _this.getDefaultImage(true, _this.store.brand, 500);
        }, function (err) { return console.error(err); }, function () {
            _this.loading(false);
        });
    };
    CategoryGroupListPage.prototype.showStore = function (store) {
        // var cats = store.menu.getAvailableCategories(store.brand);
        var now = this.convertNowDateToStoreTimeZone(store.timezone).getTime();
        var cats = this.menuManager.getAvailableCategories(store, now, this.orderManager.mode === 'takeaway');
        console.log('category group page -- cats', cats);
        if (!cats) {
            return;
        }
        this.defaultImage = this.getDefaultImage(true, this.store.brand, 500);
        // let imgCount = 0;
        if (store.menu['catLayout']) {
            // this.listMode = store.menu["catLayout"] === "list" ? true : false ;
            this.mode = store.menu.settings.catLayout;
        }
        this.imgs = [];
        for (var _i = 0, cats_2 = cats; _i < cats_2.length; _i++) {
            var cat = cats_2[_i];
            var img = cat.getImage('default', 360, true);
            if (img) {
                this.imgs.push(img);
            }
            else {
                this.imgs.push(this.defaultImage);
            }
        }
        this.categories = cats;
        console.log('assign cats', cats);
        // this.orderManager.store = store;
    };
    CategoryGroupListPage.prototype.showEmpty = function (index) {
        this.imgs[index] = this.defaultImage;
    };
    CategoryGroupListPage.prototype.ionViewDidLoad = function () {
        if (this.mode === 'list') {
            if (document.getElementsByClassName('col-card').length) {
                this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth * 0.45;
            }
        }
        else {
            if (document.getElementsByClassName('col-card').length) {
                this.cateBoxHeight = document.getElementsByClassName('col-card')[0].clientWidth;
            }
        }
    };
    CategoryGroupListPage.prototype.ionViewWillEnter = function () {
    };
    CategoryGroupListPage.prototype.ngOnDestroy = function () {
        if (!this.multOrderManager.enableMutlOrder) {
            this.orderManager.clear();
        }
    };
    CategoryGroupListPage.prototype.backButtonClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.multOrderManager.enableMutlOrder) return [3 /*break*/, 1];
                        this.navController.pop();
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(!this.multOrderManager.enableMutlOrder && this.orderManager.isEmpty())) return [3 /*break*/, 2];
                        this.navController.pop();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.alertController.create({
                            header: this.t.instant('pages.brand-store-list.alert-title'),
                            buttons: [
                                {
                                    text: this.t.instant('buttons.cancel'),
                                    handler: function () {
                                        // to do
                                        // this.googleAnalyticEventTrack('back-button-event', 'cancel');
                                    }
                                },
                                {
                                    text: this.t.instant('buttons.leave'),
                                    handler: function () {
                                        // to do
                                        // this.googleAnalyticEventTrack('back-button-event', 'back');
                                        var key = _this.storeId + '.savedOrder';
                                        _this.configService.putPreference(key, null);
                                        _this.navController.pop();
                                    }
                                }
                            ]
                        })];
                    case 3:
                        alert_1 = _a.sent();
                        alert_1.present();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CategoryGroupListPage.prototype.subCatClicked = function (category, key) {
        var _this = this;
        // need a flag
        var layout = category.layout && category.layout !== 'none' ? category.layout : this.store.menu.settings.itemLayout;
        if (key === 'Category') {
            this.currentCategories = this.categoryWithoutGroupMap[key];
        }
        else {
            this.currentCategories = this.categoryGroupMap[key];
        }
        // if(category.type === "points"){
        //     console.log("it is point type");
        //     this.pushByName(MemberPointItemPage, { store: this.store, category: category,categories:this.categories, layout:layout });
        // }else if(!layout || layout === "none"){
        //     this.pushByName(CategoryItemListPage, { store: this.store, storeId: this.store.id, categoryIndex: index });
        // }else{
        //     this.pushByName(ItemGridPage, { store: this.store, category: category,categories:this.currentCategories, layout:layout, fromCatGroupList: true});
        // }
        // if(this.orderService.isCourt){
        //     this.gaService.eventTrack("main-listing-page", 'select category - '+ this.store.name, category.name);
        // }
        var warning = (category && category['warning']) || null;
        if (warning /* && StaticService.canShowWarning*/) {
            var buttons = [
                {
                    text: this.t.instant('buttons.cancel'),
                    handler: function (value) {
                    }
                },
                {
                    text: this.t.instant('buttons.ok'),
                    handler: function (value) {
                        _this.pushByName('ItemGridPage', {
                            store: _this.store,
                            category: category,
                            categories: _this.currentCategories,
                            layout: layout,
                            fromCatGroupList: true
                        });
                        /*
                                                StaticService.warningShowTime++;
                        */
                    }
                }
            ];
            this.showAlertControlBDDismiss(null, warning, buttons, false);
        }
        else {
            this.pushByName('ItemGridPage', {
                store: this.store,
                category: category,
                categories: this.currentCategories,
                layout: layout,
                fromCatGroupList: true
            });
        }
    };
    CategoryGroupListPage.prototype.showAlertControlBDDismiss = function (title, message, buttons, enableBackdropDismiss) {
        if (buttons === void 0) { buttons = ['OK']; }
        if (enableBackdropDismiss === void 0) { enableBackdropDismiss = true; }
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!buttons) {
                            buttons = ['OK'];
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: title,
                                subHeader: message,
                                buttons: buttons,
                                backdropDismiss: enableBackdropDismiss
                            })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/, alert];
                }
            });
        });
    };
    CategoryGroupListPage.prototype.checkStoreMaxItem = function () {
        var maxItems = this.orderManager.store.menu.maxItems;
        var infinity = maxItems === 0;
        return (maxItems <= this.orderManager.count && !infinity);
    };
    CategoryGroupListPage.prototype.addItem = function (item, cat, group) {
        // this.orderService.addSingleItem(this.category, this.groups[0], item);
        var oi = this.orderManager.addSingleItem(cat, group, item, false);
        this.orderManager.getQuantity(item);
        return oi;
    };
    CategoryGroupListPage.prototype.getScore = function (recommendation) {
        var reasons = recommendation && recommendation.reasons || [];
        var score = reasons.length > 0 ? reasons[0].score : 0;
        return isNaN(score) ? 0 : Number(score).toFixed(2);
    };
    CategoryGroupListPage.prototype.recomItemclicked = function (item, recom) {
        var _this = this;
        console.log('recomItemclicked', item, recom);
        if (this.inventoryManager.isSoldout(item)) {
            return;
        }
        if (item.groupIds.length > 0) {
            var page = getSetLayout(this.settings.setLayout);
            var groups_1 = [];
            item.groupIds.forEach(function (groupId) {
                groups_1.push(_this.store.menu['gmap'][groupId]);
            });
            item.groups = groups_1;
            this.pushByName(page, {
                store: this.store,
                category: recom.category,
                groups: [recom.itemgroup],
                item: item
            });
        }
        else {
            this.orderManager.addSingleItem(recom.category, recom.itemgroup, item, false);
            // this.applyPromotion();
        }
    };
    CategoryGroupListPage.prototype.recommendationGroupclicked = function (recomGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var canGoFilter, items, _i, _a, recom, group, input, modal;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        canGoFilter = false;
                        console.log('recom group', recomGroup);
                        items = [];
                        for (_i = 0, _a = recomGroup.recommendations; _i < _a.length; _i++) {
                            recom = _a[_i];
                            items.push(recom.item);
                            if (this.isParent(recom.item)) {
                                group = recomGroup.recommendations[0].category.groups[0];
                                // if ((group.filters2 && group.filters2.length > 0) || (group.filters && group.filters.length > 0)) {
                                //     canGoFilter = true;
                                //     this.presentItemFilter(recom.item, group, (data) => {
                                //         console.log("presentItemFilter result", data);
                                //         //this.addItem(data);
                                //         if (this.isSetItem(data, recomGroup.recommendations[0].category) || data.pgroup) {
                                //             var page = this.settings.setLayout === "multi-steps" ? ToggleSetMenuPage : (this.settings.setLayout === "multi-page" ? PopUpSetMenuPage : SetSubItemsPage);
                                //             this.pushByName(page, {
                                //                 store: this.store,
                                //                 category: recomGroup.recommendations[0].category,
                                //                 groups: recomGroup.recommendations[0].category.groups,
                                //                 item: data
                                //             });
                                //         } else {
                                //             this.addItem(data, recomGroup.recommendations[0].category, recomGroup.recommendations[0].category.groups);
                                //             this.showToast(this.t.instant("global.item-added"))
                                //         }
                                //     })
                                // }
                            }
                        }
                        if (!!canGoFilter) return [3 /*break*/, 2];
                        input = { items: items, store: this.store, category: recomGroup.recommendations[0].category };
                        return [4 /*yield*/, this.modalController.create({
                                component: VariationDialog,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen'
                            })];
                    case 1:
                        modal = _b.sent();
                        modal.onWillDismiss().then(function (selected) {
                            if (selected) {
                                console.log('select & add item', selected);
                                // if (this.checkStoreMaxItem()) {
                                //     this.showStoreMaxItemAlert();
                                //     return
                                // }
                                var item = selected['data'];
                                if (_this.isSetItem(item, recomGroup.recommendations[0].category) || item.pgroup) {
                                    var page = getSetLayout(_this.settings.setLayout);
                                    _this.pushByName(page, {
                                        store: _this.store,
                                        category: recomGroup.recommendations[0].category,
                                        groups: recomGroup.recommendations[0].category.groups,
                                        item: selected
                                    });
                                }
                                else {
                                    // if(this.isReward){
                                    //         this.handleReward(selected);
                                    // }else{
                                    //     this.addItem(selected);
                                    //     this.showToast(this.t.instant("global.item-added"))
                                    // }
                                    _this.addItem(item, recomGroup.recommendations[0].category, recomGroup.recommendations[0].category.groups[0]);
                                }
                            }
                            // this.isVariationOpened = false;
                        });
                        // this.isVariationOpened = true;
                        modal.present();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CategoryGroupListPage.prototype.removeClicked = function (item) {
        console.log('remove clicked');
        // this.orderService.deleteItem(item);
        // this.orderService.minusItem(item);
        this.orderManager.minusItem(item, true);
    };
    // tapSearch  start
    CategoryGroupListPage.prototype.tapSearch = function () {
        this.pushByName('SearchItemPage', { categories: this.categories, store: this.store, storeId: this.storeId });
    };
    CategoryGroupListPage.prototype.isSet = function (item) {
        return Item.isSet(this.categories[this.currentCategoryIndex], item);
    };
    CategoryGroupListPage.prototype.transitionAni = function (data) {
        var _this = this;
        var img = data.getImage('default', 200, true);
        if (this.transitionAniWrap && img) {
            this.showTransitAni = true;
            console.log(this.transitionAniWrap);
            var imgEle_1 = document.createElement('IMG');
            imgEle_1.className = 'animated transitAni';
            imgEle_1.setAttribute('src', img);
            imgEle_1.setAttribute('width', '100');
            imgEle_1.setAttribute('height', '100');
            this.transitionAniWrap.nativeElement.appendChild(imgEle_1);
            var t_1 = setInterval(function () {
                _this.transitionAniWrap.nativeElement.removeChild(imgEle_1);
                _this.showTransitAni = false;
                clearInterval(t_1);
            }, 800);
        }
    };
    CategoryGroupListPage.prototype.pageName = function () {
        return '/category-list';
    };
    return CategoryGroupListPage;
}(BaseCategoryListPage));
export { CategoryGroupListPage };
